export const defaultPageSize = 10;

export const constants = {
  bankInfoByBik: (bik: string) => ["bank-info-by-bik", bik] as const,
  default: () => ["requisites"] as const,
  detail: (id: string) => [...constants.default(), "detail", id] as const,
  list: (pageSize: number = defaultPageSize, assetCode?: string) =>
    [...constants.default(), "list", pageSize, assetCode] as const,
};
